import { connect } from 'react-redux';

import { IAppState } from '../../../common/state';
import { INewobjectsProps, NewobjectsLoadable } from '../Newobjects';

export const NewobjectsFromDeveloperContainer = connect<INewobjectsProps>((state: IAppState) => ({
  similarNewobjects: state.similarNewobjectsFromDeveloper,
  fromDeveloper: true,
}))(NewobjectsLoadable);
